export const styles = {
  '&': {
    backgroundColor: '#212936',
    '--indent-marker-bg-color': 'rgba(255,255,255,.03)',
    '--indent-marker-active-bg-color': 'rgba(255,255,255,.1)'
  },
  '.cm-gutters': {
    backgroundColor: '#212936'
  },
  '.cm-activeLineGutter': {
    backgroundColor: '#232c3b'
  },
  '.cm-panels.cm-panels-top': {
    zIndex: 10
  },
  '.cm-panel.cm-search [name=close]': {
    color: 'var(--color-gray-700)',
    margin: 'var(--margin-base)'
  },
  '.cm-panel.cm-search label': {
    alignItems: 'center',
    display: 'inline-flex',
    gap: '4px'
  }
};
